import { useMutation, useQueryClient } from "@tanstack/react-query"
import { UpdateAgent } from "../api/AgentApi"
import { toast } from "react-toastify"
import { useIntl } from "react-intl";

export const UpdateAgentMutation  = () => {
    const queryClient = useQueryClient();
    const intl = useIntl();
    return useMutation ({
        mutationFn: UpdateAgent,
        onSuccess: (data) => {
            toast.success(intl.formatMessage({ id: 'AGENTS.UPDATE_SUCCESS' }));
            queryClient.invalidateQueries({ queryKey: ['agent'] });
            queryClient.invalidateQueries({ queryKey: ['agent', data?.data?.uID] });
        },
        onError: () => {
            toast.error(intl.formatMessage({ id: 'AGENTS.UPDATE_ERROR' }));
        } 
    })
}
